import PropTypes from "prop-types";
import React from "react";

var InputNumber = function InputNumber(_ref) {
  var className = _ref.className,
      _onChange = _ref.onChange,
      style = _ref.style,
      value = _ref.value;

  return React.createElement("input", {
    className: "token number " + className,
    onChange: function onChange(e) {
      return _onChange(e.target.value, e.target.validity.valid);
    },
    style: style,
    type: "number",
    value: value
  });
};

InputNumber.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  style: PropTypes.object,
  value: PropTypes.number.isRequired
} : {};

InputNumber.defaultProps = {
  className: "",
  style: {}
};

export default InputNumber;